export default "__VITE_ASSET__Bk8E500N__"